import './Home.css';

import HeroSection from '../components/Home/HeroSection';
import ServicesSection from '../components/Home/ServicesSection';
import {
  AboutSection,
  ProcessSection,
  ProjectsSection,
  TestimonialsSection,
  CTASection,
} from '../components/Home/index';
import TechStackSection from '../components/Home/TechStackSection';

const Home = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ProcessSection />
      <ProjectsSection />
      <TechStackSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
};

export default Home;
